import DataUS from "./content-us_en.json"

export default (page) => {
  return DataUS[page];
}